import React from "react";
import { Card } from "antd";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    BarChart,
    Bar,
    Legend,
    ResponsiveContainer,
} from "recharts";

/* ===================== CONFIG ===================== */

const lineChartConfig = {
    title: "Total Work Assigned vs Completed Trend",
    data: [
        { week: "Week 1", assigned: 11, completed: 10 },
        { week: "Week 2", assigned: 10, completed: 6 },
        { week: "Week 3", assigned: 10, completed: 7 },
        { week: "Week 4", assigned: 11, completed: 7 },
        { week: "Week 5", assigned: 10, completed: 6 },
    ],
    colors: {
        assigned: "#1f3bb3",
        completed: "#0b5d1e",
    },
};

const barChartConfig = {
    title: "On-Time vs Delayed Work",
    data: [
        { week: "Week 1", assigned: 14, completed: 13 },
        { week: "Week 2", assigned: 15, completed: 14 },
        { week: "Week 3", assigned: 14, completed: 14 },
        { week: "Week 4", assigned: 15, completed: 15 },
    ],
    colors: {
        assigned: "#a3d600",
        completed: "#ff5ca8",
    },
};

/* ===================== COMPONENT ===================== */

const WorkDashboard: React.FC = () => {
    return (
        <div className="mt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Line Chart Card */}
                <Card className="rounded-xl shadow-sm">
                    <h3 className="text-sm font-semibold text-gray-700 mb-4">
                        {lineChartConfig.title}
                    </h3>

                    <div className="h-[260px]">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={lineChartConfig.data}>
                                <CartesianGrid
                                    strokeDasharray="3 3"
                                    vertical={false}
                                    stroke="#e5e7eb"
                                />
                                <XAxis
                                    dataKey="week"
                                    tick={{ fontSize: 12, fill: "#6b7280" }}
                                />
                                <YAxis
                                    tick={{ fontSize: 12, fill: "#6b7280" }}
                                    domain={[0, 20]}
                                />
                                <Tooltip />
                                <Legend
                                    verticalAlign="bottom"
                                    iconType="square"
                                    wrapperStyle={{ fontSize: 12 }}
                                />
                                <Line
                                    type="monotone"
                                    dataKey="assigned"
                                    stroke={lineChartConfig.colors.assigned}
                                    strokeWidth={2.5}
                                    dot={false}
                                    name="Assigned Project"
                                />
                                <Line
                                    type="monotone"
                                    dataKey="completed"
                                    stroke={lineChartConfig.colors.completed}
                                    strokeWidth={2.5}
                                    dot={false}
                                    name="Completed Project"
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </Card>

                {/* Bar Chart Card */}
                <Card className="rounded-xl shadow-sm">
                    <h3 className="text-sm font-semibold text-gray-700 mb-4">
                        {barChartConfig.title}
                    </h3>

                    <div className="h-[260px]">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={barChartConfig.data} barGap={8}>
                                <CartesianGrid
                                    strokeDasharray="3 3"
                                    vertical={false}
                                    stroke="#e5e7eb"
                                />
                                <XAxis
                                    dataKey="week"
                                    tick={{ fontSize: 12, fill: "#6b7280" }}
                                />
                                <YAxis
                                    tick={{ fontSize: 12, fill: "#6b7280" }}
                                    domain={[0, 20]}
                                />
                                <Tooltip />
                                <Legend
                                    verticalAlign="bottom"
                                    iconType="square"
                                    wrapperStyle={{ fontSize: 12 }}
                                />
                                <Bar
                                    dataKey="assigned"
                                    fill={barChartConfig.colors.assigned}
                                    radius={[4, 4, 0, 0]}
                                    name="Assigned Project"
                                />
                                <Bar
                                    dataKey="completed"
                                    fill={barChartConfig.colors.completed}
                                    radius={[4, 4, 0, 0]}
                                    name="Completed Project"
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default WorkDashboard;
